// RootRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";

// Auth pages
import Login from "Pages/Common/Auth/Login";
import CreatePassword from "Pages/Common/Auth/CreatePassword";
import ForgotPassword from "Pages/Common/Auth/ForgotPassword";
import ContactUs from "Pages/Common/Auth/ContactUs";
import PasswordSuccess from "Pages/Common/Auth/PasswordSuccess";

// Protected pages (User)
import UserDashboard from "Pages/Protected/User/Dashboard";
import UserAssessmentDetails from "Pages/Protected/User/AssessmentDetails";
import UserAssessmentJourney from "Pages/Protected/User/AssessmentJourney";
import UserPreAssessment from "Pages/Protected/User/PreAssessment";
import PreAssessmentQuestion from "Pages/Protected/User/PreAssessmentQuestion";
import UserPreAssessmentRecommendation from "Pages/Protected/User/PreAssessmentRecommedations";
import PreAssessmentView from "Pages/Protected/User/PreAssessmentView";
import UserRecommendations from "Pages/Protected/User/Recommendations";
import UserSettings from "Pages/Protected/User/Settings";

// Protected pages (Accessor)
import AccessorDashboard from "Pages/Protected/Accessor/Dashboard";
import AccessorAssessmentTracker from "Pages/Protected/Accessor/AssessmentTracker";
import AccessorAssessmentReview from "Pages/Protected/Accessor/AssessmentReview";
import AccessorSettings from "Pages/Protected/Accessor/Settings";
import AccessorViewAssessmentReview from "Pages/Protected/Accessor/ViewReviewAssessment";
import StoreAudit from "Pages/Protected/Accessor/StoreAudit";
import SparePartsAudit from "Pages/Protected/Accessor/SparePartsAudit";

// Protected pages (Approver)
import ApproverApprovalViewDetail from "../Pages/Protected/Approver/ApprovalViewDetail";
import ApproverApproval from "../Pages/Protected/Approver/Approval";

// Protected pages (Admin)
import AdminDashboard from "Pages/Protected/Admin/Dashboard";
import AdminAssessmentBacklog from "Pages/Protected/Admin/AssessmentBacklog";
import ContactUsList from "Pages/Protected/Admin/ContactUs";
import AdminAddAssessmentBacklog from "Pages/Protected/Admin/AddAssessmentBacklog";
import AdminUpdateAssessmentBacklog from "Pages/Protected/Admin/UpdateAssessment";
import AdminViewAssessmentBacklog from "Pages/Protected/Admin/ViewAssessment";
import AdminAssessmentBacklogSuccess from "Pages/Protected/Admin/AssessmentBacklogSuccess";
import AdminReports from "Pages/Protected/Admin/Reports";
import AdminReportsDetails from "Pages/Protected/Admin/ReportsDetails";
import AdminReportsAssessmentDetails from "Pages/Protected/Admin/AssessmentDetails";
import AdminStaffManagement from "Pages/Protected/Admin/StaffManagement";
import AdminSettings from "Pages/Protected/Admin/Settings";
import AdminAddUpdateStaff from "Pages/Protected/Admin/AddUpdateStaff";
import AdminViewStaff from "Pages/Protected/Admin/viewStaff";

// Common pages
import NotFound from "Pages/Common/NotFound";
import NoInternet from "Pages/Common/NoInternet";

// Protected Routes
import ProtectedRoutes from "./ProtectedRoutes";
import PreviewSubmitted from "Pages/Protected/Accessor/PreviewSubmitted";
import ApprovalPreview from "Pages/Protected/Approver/ApprovalPreview";

function RootRoutes() {
  const userDetails = JSON.parse(localStorage.getItem("userDetails")); // Retrieve user details

  return (
    <Routes>
      {/* Auth routes */}
      {!userDetails?.role && (
        <>
          <Route path="/" element={<Login />} />
          <Route path="/create-password" element={<CreatePassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/password-success" element={<PasswordSuccess />} />
        </>
      )}

      {/* User routes (protected) */}
      {userDetails?.role === 3 && (
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<UserDashboard />} />
          <Route
            path="/dashboard/:assessmentId/:subCategoryId"
            element={<UserAssessmentDetails />}
          />
          <Route
            path="/pre-assessment/:assessmentId/assessment-journey"
            element={<UserAssessmentJourney />}
          ></Route>
          <Route path="/pre-assessment" element={<UserPreAssessment />} />
          {/* <Route
            path="/pre-assessment/:detailsId"
            element={<UserPreAssessmentDetails />}
          /> */}
          <Route
            path="/pre-assessment/questions/:backlog_id"
            element={<PreAssessmentQuestion />}
          />
          <Route path="/recommendations" element={<UserRecommendations />} />
          <Route
            path="/recommendations/recommendation/:AssessmentId"
            element={<UserPreAssessmentRecommendation />}
          />
          <Route
            path="/pre-assessment/view/:AssessmentId"
            element={<PreAssessmentView />}
          />
          <Route path="/settings" element={<UserSettings />} />

          <Route path="/create-password" element={<CreatePassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/password-success" element={<PasswordSuccess />} />
        </Route>
      )}

      {/* Accessor routes (protected) */}
      {userDetails?.role === 2 && (
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<AccessorDashboard />} />
          <Route
            path="/assessment-tracker"
            element={<AccessorAssessmentTracker />}
          />
          <Route
            path="/assessment-review"
            element={<AccessorAssessmentReview />}
          />
          <Route
            path="/assessment-review/view-assessment/:AssesmentId"
            element={<AccessorViewAssessmentReview />}
          />
          <Route
            path="/assessment-review/view-assessment/preview/:AssesmentId"
            element={<PreviewSubmitted />}
          />
          <Route
            path="/store-audit"
            element={<StoreAudit />}
          />
          <Route
            path="/store-audit/spare-parts/:backlog_id"
            element={<SparePartsAudit />}
          />
          <Route path="/settings" element={<AccessorSettings />} />

          <Route path="/create-password" element={<CreatePassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/password-success" element={<PasswordSuccess />} />
        </Route>
      )}

      {/* Approver routes (protected) */}
      {userDetails?.role === 4 && (
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<ApproverApproval />} />
          <Route
            path="/approval/view-detail/:AssesmentId"
            element={<ApproverApprovalViewDetail />}
          />
           <Route
            path="/approval/view-detail/preview/:AssesmentId"
            element={<ApprovalPreview />}
          />
          <Route path="/create-password" element={<CreatePassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/password-success" element={<PasswordSuccess />} />
        </Route>
      )}

      {/* Admin routes (protected) */}
      {userDetails?.role === 1 && (
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<AdminDashboard />} />
          <Route
            path="/contactUs"
            element={<ContactUsList />}
          />
          <Route
            path="/assessment-backlogs"
            element={<AdminAssessmentBacklog />}
          />
          <Route
            path="/assessment-backlogs/add"
            element={<AdminAddAssessmentBacklog />}
          />
          <Route
            path="/assessment-backlogs/update"
            element={<AdminUpdateAssessmentBacklog />}
          />
          <Route
            path="/assessment-backlogs/view"
            element={<AdminViewAssessmentBacklog />}
          />
          <Route
            path="/assessment-backlogs-success"
            element={<AdminAssessmentBacklogSuccess />}
          />
          <Route path="/reports" element={<AdminReports />} />
          <Route
            path="/reports/report-details/:reportId"
            element={<AdminReportsDetails />}
          />
          <Route
            path="/reports/report-details/Assessment/:assessmentId/:subCategoryId"
            element={<AdminReportsAssessmentDetails />}
          />
          <Route path="/staff-management" element={<AdminStaffManagement />} />
          <Route
            path="/staff-management/add-update-staff"
            element={<AdminAddUpdateStaff />}
          />
          <Route path="/view-staff" element={<AdminViewStaff />} />
          <Route path="/settings" element={<AdminSettings />} />

          <Route path="/create-password" element={<CreatePassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/password-success" element={<PasswordSuccess />} />
        </Route>
      )}

      {/* 404 route */}
      <Route path="*" element={<NotFound />} />

      {/* No Internet route */}
      <Route path="/no-internet" element={<NoInternet />} />
    </Routes>
  );
}

export default RootRoutes;
